const sanitizeSensitiveData = (message) => {
    if (!message) {
        return message;
    }

    return (
        message
            // Mask UUIDs first (more specific pattern, should be checked before phone numbers)
            .replace(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi, '[UUID_REDACTED]')
            // Mask email addresses
            .replace(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi, '[EMAIL_REDACTED]')
            // Mask phone numbers (basic pattern)
            .replace(/(\+?\d{1,3}[-.\s]?)?\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}/g, '[PHONE_REDACTED]')
            // Mask tokens/keys (long alphanumeric strings)
            .replace(/\b[A-Za-z0-9]{32,}\b/g, '[TOKEN_REDACTED]')
    );
};

const initializeDatadogRum = ({ clientToken, applicationId, site }) => {
    if (!window.DD_RUM) {
        // eslint-disable-next-line no-console
        console.error('Datadog RUM not found on window object');
        return;
    }

    window.DD_RUM.init({
        clientToken: clientToken,
        applicationId: applicationId,
        site: site,
        env: localStorage.getItem('environment') || 'development',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 100,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input',
        version: process.env.REACT_APP_VERSION || '1.0.0',
        // beforeSend can be used to redact sensitive data from events
        beforeSend: (event) => {
            // Sanitize error messages to remove PII
            if (event.type === 'error' && event.error?.message) {
                event.error.message = sanitizeSensitiveData(event.error.message);
            }

            // Sanitize error stack traces
            if (event.error?.stack) {
                event.error.stack = sanitizeSensitiveData(event.error.stack);
            }

            // Sanitize resource URLs that might contain sensitive query params
            if (event.type === 'resource' && event.resource?.url) {
                try {
                    const url = new URL(event.resource.url);
                    // Remove sensitive query parameters
                    const sensitiveParams = ['token', 'access_token', 'api_key', 'apikey', 'password'];

                    sensitiveParams.forEach((param) => {
                        if (url.searchParams.has(param)) {
                            url.searchParams.set(param, '[REDACTED]');
                        }
                    });
                    event.resource.url = url.toString();
                } catch (e) {
                    // Invalid URL, skip sanitization
                }
            }

            return true; // Return false to drop the event entirely
        },
    });
};

export const startDatadogRUM = (datadogConfig) => {
    const { clientToken = '', applicationId = '', site = '' } = datadogConfig || {};

    // Check if all required config is present
    if (!clientToken || !applicationId || !site) {
        return;
    }

    const scriptId = 'datadog-rum-script';

    // Prevent duplicate script loading
    if (!document.getElementById(scriptId)) {
        const script = document.createElement('script');

        script.id = scriptId;
        script.src = 'https://www.datadoghq-browser-agent.com/datadog-rum-v6.js';
        script.onload = () => initializeDatadogRum({ clientToken, applicationId, site });
        script.onerror = () => {
            // eslint-disable-next-line no-console
            console.error('Error loading Datadog RUM script');
        };
        document.head.appendChild(script);
    } else {
        // Script already loaded, just initialize
        initializeDatadogRum(datadogConfig);
    }
};
